var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "text-edit",
    class: {
      'bg-white': _vm.isTranslationEdit,
      'bg-gray': !_vm.isTranslationEdit,
      'cursor-text': _vm.isTranslationEdit && !_vm.disableRichText,
      'text-edit-outline': _vm.isRichTextFocused
    },
    on: {
      "click": _vm.handleTextEditClick
    }
  }, [!_vm.isTranslationEdit ? _c('style-bar', {
    staticClass: "mb-2",
    attrs: {
      "css-keys": ['color', 'background', 'fontSize', 'textAlign'],
      "mode": "text",
      "styles": _vm.localStyles
    },
    on: {
      "update:styles": function updateStyles($event) {
        _vm.localStyles = $event;
      }
    }
  }) : _vm._e(), _c('rich-text-input', {
    staticClass: "px-2 py-2",
    style: _vm.localStyles,
    attrs: {
      "global-tab-classes": _vm.childClasses,
      "disable-input": _vm.disableRichText,
      "disable-variables": _vm.disableVariables,
      "mode": "textarea",
      "content": _vm.editorContent,
      "json": _vm.editorContentJson,
      "placeholder": _vm.placeholder || (!_vm.isTranslationEdit ? _vm.$t('enter_text_here') : '')
    },
    on: {
      "rich-text-input-focused": _vm.handleFocus,
      "rich-text-input-blurred": _vm.handleBlur,
      "update:content": function updateContent($event) {
        _vm.editorContent = $event;
      },
      "update:json": function updateJson($event) {
        _vm.editorContentJson = $event;
      }
    }
  })], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }